module.exports = __webpack_public_path__ + "img/passwordchange1.fa101a59.png";